import React from 'react';
import classNames from 'classnames';

import css from './IconDownload.module.css';

/**
 * Download icon.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own root class
 * @param {string?} props.rootClassName overwrite components own root class
 * @returns {JSX.Element} SVG icon
 */
const IconDownload = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="64"
      viewBox="0 0 16 16"
    >
      <path
        id="SVGRepo_iconCarrier"
        fillRule="evenodd"
        d="M7 5.222V0h2v5.193l1.107-1.107L11.52 5.5 7.986 9.036 4.45 5.5l1.414-1.414zM16 11v5H0v-5h2v3h12v-3z"
      ></path>
    </svg>
  );
};

export default IconDownload;
